import React from 'react';

interface PinIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const PinIcon: React.FC<PinIconProps> = ({ className = '', color = '#2C6CFF', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M8.65088 16.4619L4.90088 20.2119M14.8669 3.49548L9.02481 9.33752C9.02481 9.33752 6.42881 8.03345 3.64481 10.2834C3.56281 10.3494 3.49481 10.4335 3.44681 10.5275C3.39881 10.6215 3.37285 10.7235 3.36685 10.8295C3.36085 10.9335 3.3789 11.0395 3.4169 11.1375C3.4549 11.2355 3.51282 11.3254 3.58682 11.3994L13.6949 21.5055C13.7689 21.5815 13.8608 21.6415 13.9628 21.6815C14.0628 21.7195 14.1708 21.7354 14.2788 21.7274C14.3868 21.7214 14.4908 21.6915 14.5868 21.6395C14.6808 21.5875 14.7629 21.5174 14.8289 21.4294C15.6169 20.3894 16.8528 18.2335 15.7748 16.0875L21.6088 10.2455C21.6888 10.1755 21.7489 10.0935 21.7889 10.0015C21.8289 9.90946 21.8488 9.81143 21.8488 9.71143C21.8488 9.61143 21.8289 9.51351 21.7889 9.42151C21.7489 9.32951 21.6888 9.24749 21.6088 9.17749L15.9348 3.49548C15.8648 3.42548 15.7808 3.36947 15.6908 3.32947C15.5988 3.29147 15.4988 3.27148 15.4008 3.27148C15.3008 3.27148 15.2029 3.29147 15.1109 3.32947C15.0189 3.36947 14.9349 3.42548 14.8669 3.49548Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PinIcon;
